import React from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import './RemoveUserModal.scss';

interface User {
    label: string;
    value: string;
    email: string;
    isOwner: boolean;
}

interface RemoveUserModalProps {
    visible: boolean;
    title: string;
    userRemove: User;
    onCancel: () => void;
    onRemoveConfirm: (user: any) => void;
    children?: React.ReactNode;
    modalStyle?: React.CSSProperties;
    footerStyle?: React.CSSProperties;
    bodyStyle?: React.CSSProperties;
}

const RemoveUserModal: React.FC<RemoveUserModalProps> = ({
    visible,
    title,
    userRemove,
    onCancel,
    onRemoveConfirm,
    //children,
    modalStyle,
    footerStyle,
    bodyStyle,
}) => {
    const handleConfirmButtonClick = () => {
        onRemoveConfirm(userRemove);
    };

    return (
        <Modal
            visible={visible}
            title={title}
            ariaLabel={title}
            onCancel={onCancel}
            modalStyle={modalStyle}
            footerStyle={footerStyle}
            bodyStyle={bodyStyle}
            footer={
                <div className="d-flex">
                    <Button kind="secondary" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button kind="negative" onClick={handleConfirmButtonClick}>
                        Remove
                    </Button>
                </div>
            }>
            <div className="ap-typography-body">
                Are you sure you want to remove this user? They will no longer be able to have access.
            </div>
        </Modal>
    );
};

export default RemoveUserModal;
